import React from 'react';
import { NewPassword } from '../../../modules/forgotPassword/components/NewPassword/NewPassword';

export function NewPasswordPage() {
	return <NewPassword />;
}
